import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvy3y88zdf: FaireProductEntity = {
  token: "p_dvy3y88zdf",
  type: "product",
  name: "Devotion Wooden Drum - Kids Toy",
  brandToken: "b_b2bxmek3gf",
  brandName: "Kingdom Come Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e07ad189c3bdfb2cfb5fb55866e1aeaf39942a975f5e124136f4d8d3a293e2e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f781f9f60d9fa452e2863b6f44c7180d766267d28cbc24ae5809df719b73ce65.jpeg",
    "https://cdn.faire.com/fastly/8d5ae096bad770377b28a9104133acfeff7938aff76bdd612519b41566fb6ce1.jpeg",
    "https://cdn.faire.com/fastly/5a870654787ba9b986662b6e50387bfc079b3120c095bfdc49d4488261387770.jpeg",
    "https://cdn.faire.com/fastly/f31adac3534231545a2dffb51ab9722f0fe966e8afad7ee8f51053a1a49fd5fd.jpeg",
    "https://cdn.faire.com/fastly/40767bf6b3a7de71281a97e4caad2286263161abc238ea451f94779b2bf80b4b.jpeg",
    "https://cdn.faire.com/fastly/f312394cae49eb7d7a52f6710bec07123243fdf56ff88d9348278178ea8cbb72.jpeg",
  ],
  priceDollars: 22.52,
  description:
    "\nIntroducing the Devotion Drum, the newest addition to Kingdom Come Co.'s lineup of Christian toys! This toy spinning drum is specially designed for babies and toddlers, helping them to learn and grow in their faith from an early age.\n\nAll sides of the Devotion Drum features an affirmation Bible verse that encourages positive thinking and reminds little ones of God's love. With colorful and engaging illustrations, this toy is sure to capture your child's attention and spark their curiosity about the Bible.\n\nNot only is the Devotion Drum a fun and interactive toy for your child, but it also provides a valuable opportunity for parents to engage in meaningful conversations with their little ones about faith and the importance of Scripture.",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:20.868Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
